import * as React from "react";
import { forwardRef, memo } from "react";
const SvgJm = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 6", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h12v6H0z" }))), /* @__PURE__ */ React.createElement("path", { fill: "#007749", d: "M0 0h12v6H0z" }), /* @__PURE__ */ React.createElement("path", { fill: "#2d2926", stroke: "#ffb81c", clipPath: "url(#a)", d: "M-2-1v8l16-8v8z" }));
const ForwardRef = forwardRef(SvgJm);
const Memo = memo(ForwardRef);
export default Memo;
